import { Suspense, lazy } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { Permissions, ProtectedRoute } from '@kp/react-sdk';

import { Loader } from './components/Loader';
import { PageLayout } from './components/PageLayout';
import { ROUTES } from './constants/routes';
import { NotFoundHandler } from './contexts/generic-page-context';
import { Home } from './features/home';
import { LegalRoutes } from './features/legals';

const UserAccessManagement = lazy(() =>
  import('./features/user-access-management').then((module) => ({
    default: module.UserAccessManagement,
  })),
);

const App = () => (
  <PageLayout>
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route
          path={ROUTES.root}
          element={<Navigate to={ROUTES.home} replace />}
        />

        <Route element={<ProtectedRoute element={<Outlet />} />}>
          <Route path={ROUTES.home} element={<Home />} />
        </Route>

        <Route
          element={
            <ProtectedRoute
              permission={Permissions.UsersRead}
              element={<Outlet />}
            />
          }
        >
          <Route
            path={ROUTES.userManagement}
            element={<UserAccessManagement />}
          />
        </Route>

        <Route path={`${ROUTES.legals}/*`} element={<LegalRoutes />} />

        <Route path="*" element={<NotFoundHandler />} />
      </Routes>
    </Suspense>
  </PageLayout>
);

export default App;
